// Phase 0 token registry. Future phases append entries here (and to the matching CSS
// variables in src/index.css + tailwind.config.js) — this file is the only place that needs
// to change to teach the rest of the branding module about a new token. See
// docs/plan/brand-kit/README.md §3.2 in the sms-modular-monolith-ddd repo.

export type BrandTokenDefinition = {
  key: string;
  label: string;
  cssVariable: string;
  defaultValue: string;
  // The token this one is checked for WCAG AA contrast against, if any.
  contrastPairKey?: string;
};

export const BRAND_TOKEN_REGISTRY: readonly BrandTokenDefinition[] = [
  {
    key: "sidebar.background",
    label: "Sidebar Background",
    cssVariable: "--brand-sidebar-background",
    defaultValue: "#ffffff",
    contrastPairKey: "sidebar.text",
  },
  {
    key: "sidebar.text",
    label: "Sidebar Text",
    cssVariable: "--brand-sidebar-text",
    defaultValue: "#334155",
  },
  {
    key: "sidebar.hover",
    label: "Sidebar Hover",
    cssVariable: "--brand-sidebar-hover",
    defaultValue: "#f1f5f9",
    contrastPairKey: "sidebar.text",
  },
  {
    key: "sidebar.active",
    label: "Sidebar Active",
    cssVariable: "--brand-sidebar-active",
    defaultValue: "#f1f5f9",
    contrastPairKey: "sidebar.text",
  },
] as const;

export const DEFAULT_BRAND_TOKENS: Record<string, string> = Object.fromEntries(
  BRAND_TOKEN_REGISTRY.map((token) => [token.key, token.defaultValue]),
);
